import React from 'react';
import { useNavigate } from 'react-router-dom';

const BORDER_LIGHT = '#D1D5DB';
const TEXT_SECONDARY = '#6B7280';

interface BackButtonProps {
  onClick?: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={onClick ?? (() => navigate(-1))}
      aria-label="Back"
      style={{
        direction: 'ltr',
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(59, 123, 244, 0.08)',
        border: `1px solid ${BORDER_LIGHT}`,
        borderRadius: '50%',
        color: TEXT_SECONDARY,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        fontSize: 18,
        padding: 0,
        flexShrink: 0,
      }}
    >
      ‹
    </button>
  );
};

export default BackButton;
